module.exports = __webpack_public_path__ + "img/hvad-har-du-lavet-1.82911af1.png";